/**
 * Custom js to display homepage slider
 *
 * @since		09/21/2020
 * @author		<john@chatmandesign.com>
 * @link		http://chatmandesign.com
 */
(function ($) {
	let transitionDur = 750;
	let searchDisplay = ".search-display";
	let activeClass = "is-open";
	let activeSearchClass = "is-activated";

	let $searchDisplay = $(".search-display > button");
	let $searchSubmit = $(searchDisplay + " .search-submit");
	let searchForm = searchDisplay + "__form";
	let $searchForm = $(searchDisplay + "__form");
	let $searchField = $(searchForm + " .search-field");

	function initSearchModal() {
		if ($searchForm.length) {
			$searchForm.appendTo("body");
		}
	}

	function toggleSearchModal() {
		if ($searchForm.hasClass(activeClass)) {
			closeSearchModal();
		} else {
			openSearchModal();
		}
	}

	function openSearchModal() {
		$searchForm.css("display", "block");
		setTimeout(function () {
			$searchForm.addClass(activeClass);
			$searchField.focus();
		}, 50);
		toggleSearchIcon(true);
	}

	function closeSearchModal() {
		$searchForm.removeClass(activeClass);
		setTimeout(function () {
			$searchForm.css("display", "none");
		}, transitionDur + 50); // little extra for full fade
		toggleSearchIcon(false);
	}

	function toggleSearchIcon(isOpen) {
		$searchSubmit.find("> div").each(function () {
			let $icon = $(this);
			let isOpenIcon = $icon.hasClass("open");
			if (isOpen) {
				if (isOpenIcon) {
					$icon.addClass(activeClass);
				} else {
					$icon.removeClass(activeClass);
				}
			} else {
				if (isOpenIcon) {
					$icon.removeClass(activeClass);
				} else {
					$icon.addClass(activeClass);
				}
			}
			//only two states
			$(this).toggleClass(activeClass);
		});
	}

	function windowHandleKeydown(event) {
		if ($searchForm.hasClass(activeClass)) {
			if (event.keyCode == 27) {
				toggleSearchIcon(false);
				closeSearchModal();
			}
		}
	}

	$(document).ready(function () {
		initSearchModal();

		$searchDisplay.on("click", function (event) {
			toggleSearchModal(true);
		});

		$searchField.on({
			blur: function (event) {
				if (!$(event.relatedTarget).hasClass("search-submit"))
					closeSearchModal();
			},
		});

		$searchSubmit.on({
			blur: function (event) {
				if (!$(event.relatedTarget).hasClass("search-field"))
					closeSearchModal();
			},
		});

		$(window).on("keydown", function (event) {
			windowHandleKeydown(event);
		});
	});
})(jQuery);
